<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='文章管理' subPath='文章来源'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-select v-model="param.source_id" placeholder="请选择来源" @change="sourceChange" filterable>
            <el-option label="请选择来源" :value="0"></el-option>
            <el-option v-for="item in sourceList" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4" v-if="param.source_id!=3">
          <el-select v-model="param.category_pid" placeholder="请选择栏目" @change="categoryParentChange" filterable>
            <el-option label="请选择栏目" :value="0"></el-option>
            <el-option v-for="item in categoryParentList" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="param.category_id" placeholder="请选择分类" @change="getArticleList" filterable>
            <el-option label="请选择分类" :value="0"></el-option>
            <el-option v-for="item in categoryList" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-input placeholder="请输入文章标题" v-model="param.keyword" clearable @clear="getArticleList">
            <el-button slot="append" icon="el-icon-search" @click="getArticleList"></el-button>
          </el-input>
        </el-col>
      </el-row>
    </el-card>
    <el-table :data="articleList" stripe border :cell-style="{ textAlign: 'center' }">
      <el-table-column prop="id" label="ID" align="center" width="70px"></el-table-column>
      <el-table-column label="标题" align="center">
        <template slot-scope="scope">
          <a :href="scope.row.url" target="_blank">{{scope.row.title}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="category_title" label="分类" align="center"></el-table-column>
      <el-table-column prop="author" label="作者" align="center"></el-table-column>
      <el-table-column label="发布时间" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.publish_time>0">{{scope.row.publish_time | dateTimeFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="290px">
        <template slot-scope="scope">
          <el-button v-if="scope.row.is_sync==1" type="success" disabled size="mini">已同步</el-button>
          <el-button v-else type="primary" icon="el-icon-edit" size="mini" @click="syncArticle(scope.row.id)">同步</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="param.page"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="param.count"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
export default {
  name: 'handpick_source_article_list',
  components: {
    'bread-crumb': BreadCrumb
  },
  data () {
    return {
      sourceList: [],
      categoryParentList: [],
      categoryList: [],
      articleList: [],
      total: 0,
      pageTotal: 1,
      param: {
        source_id: 0,
        category_pid: 0,
        category_id: 0,
        keyword: '',
        page: 1,
        count: 10
      }
    }
  },
  created () {
    this.getSourceList()
  },
  methods: {
    sourceChange () {
      if (this.param.source_id === 0) {
        this.param.category_pid = 0
        this.param.category_id = 0
        this.param.keyword = ''
        this.param.page = 1
        this.param.count = 10
        this.total = 0
        this.pageTotal = 1
        this.categoryParentList = []
        this.categoryList = []
        this.articleList = []
      } else {
        if (this.param.source_id === 3) {
          this.getCategoryList()
        } else {
          this.getCategoryParentList()
        }
        this.getArticleList()
      }
    },
    categoryParentChange () {
      this.param.page = 1
      this.param.category_id = 0
      this.param.keyword = ''
      this.getCategoryList()
      this.getArticleList()
    },
    async getSourceList () {
      const res = await this.$http.get('/admin/handpick_source/select_list')
      if (res.code === 0) {
        this.sourceList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getCategoryParentList () {
      const res = await this.$http.get('/admin/handpick_source_article/category_list', {
        source_id: this.param.source_id
      })
      if (res.code === 0) {
        this.categoryParentList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getCategoryList () {
      const res = await this.$http.get('/admin/handpick_source_article/category_list', {
        source_id: this.param.source_id,
        parent_id: this.param.category_pid
      })
      if (res.code === 0) {
        this.categoryList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getArticleList () {
      if (this.param.source_id === 0) {
        this.$message.error('请选择来源')
      } else {
        const res = await this.$http.get('/admin/handpick_source_article/article_list', this.param)
        if (res.code === 0) {
          this.articleList = res.data.list
          this.total = res.data.total
          this.pageTotal = res.data.total_page
        } else {
          this.$message.error(res.msg)
        }
      }
    },
    async syncArticle (id) {
      const res = await this.$http.post('/admin/handpick_source_article/sync_article', {
        source_id: this.param.source_id,
        article_id: id
      })
      if (res.code === 0) {
        this.$message.success('同步成功')
        this.getArticleList()
      } else {
        this.$message.error(res.msg)
      }
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getArticleList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getArticleList()
    }
  }
}
</script>

<style scoped>
</style>
